/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Produktgruppen im Landscape-Format anzeigen
 * 
 */

import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import PDFFrame from "../../partials/PDFFrame";
import VideoFrame from "../../partials/VideoFrame";
import GroupMainImage from "./GroupMainImage";

import * as portfolioActions from '../../../store/actions/portfolioActions';
import * as fileActions from "../../../store/actions/fileActions";
import * as appActions from "../../../store/actions/appActions";
import * as utils from "../../../basics/utils";

// ###############################################################
// GroupDetailsLandscpe / Details der Gruppe anzeigen
// ---------------------------------------------------------------
// Wurde noch keine Produktgruppe ausgewählt, so werden zunächst  
// die Details der Produktgruppe angezeigt. Die Details werden
// in drei Spalten angezeigt:
// 1. Spalte - Gruppen Bild
// 2. Spalte - vertikale Liste aller PDF-Dokumente zur Produktgruppe
// 3. Spalte - vertikale Liste aller MP4-Viedeos zur Produktgruppe
// 
// Vorlage: Mockups_Produktgruppe_navi.jpg
// ###############################################################
class GroupLandscape extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { inputHeight, path, appModus } = this.props.app;

        const dialog = utils.getDialogByPath(path);

        const node = utils.getTreePortfolio(dialog.portfolio, false);
        if (node === null) return null;

        if (dialog.groups !== '') return null;

        const scrollBarClass = (window['cordova']) ? 'overflow-y-hidden' : 'overflow-y-auto';

        const renderPDF_column = () => {

            const renderPDF = (d, i) => {
                return (
                    <div key={i} className="w-full pb-1">
                        <PDFFrame key={i} node={d} type='portfolio' listView={false} />
                    </div>
                )
            }

            const files = utils.getNodeFiles(node, 'pdf');

            return (
                <div className={`w-1/2 flex flex-col overflow-x-hidden ${scrollBarClass}`}>
                    {appModus === 'Admin' && renderPDF({ name: '_NEW', path: '' })}
                    {files.map((d, i) => renderPDF(d, i))}
                </div>
            )
        }

        const renderMP4_column = () => {

            const renderVideo = (d, i) => {
                return (
                    <div key={i} className={"w-full " + (d.name === '_NEW' ? 'pb-2' : '')}>
                        <VideoFrame key={i} fileName={d.name} type='portfolio' />
                    </div>
                )
            }

            const files = utils.getNodeFiles(node, 'mp4');

            return (
                <div className={`w-1/2 flex flex-col overflow-x-hidden ${scrollBarClass}`}>
                    {appModus === 'Admin' && renderVideo({ name: '_NEW', path: '' })}
                    {files.map((d, i) => renderVideo(d, i))}
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        const style = {
            left: '20%',
            width: '80%',
            height: inputHeight,
        };

        return (
            <div key='a' className="absolute w-full flex z-20 bg-forsales-gray" style={style}>
                <div className="w-7/12 h-full" >
                    <GroupMainImage node={node} />
                </div>
                <div className="w-5/12 h-full p-2 flex" >
                    {renderPDF_column()}
                    {renderMP4_column()}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        file: state.file,
        portfolio: state.portfolio
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupLandscape);
